<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container">
                    <div class="lds-ring" v-if="!isLoad">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <section class="section-hotels section-hotels-2" v-if="isLoad">
                        <div class="page-title">
                            <h2>Hotels</h2>
                            <div class="page-title__side">
                                <form>

                                    <div class="form-control-wrap search-hotel">
                                        <input type="text" placeholder="Search" v-model="search"
                                               class="form-control-search"/>
                                        <div class="form-control-icon">
                                            <svg width="1em" height="1em" class="icon icon-search ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <router-link to="/hotels/add" href="javascript:void(0)"
                                                 class="btn btn--green btn_add-hotel"><span>Add Hotel</span>
                                    </router-link>
                                </form>
                            </div>
                        </div>

                        <div class="hotels-table">
                            <simplebar class="section-table-wrap">
                                <table class="default-table-2 table-hotels table-hotels_2">
                                    <thead>
                                    <tr>
                                        <th class="default-table-2__th default-table-2-title">
                          <span>
                            Hotel
                          </span>
                                        </th>

                                        <th class="default-table-2__th td-last-update">
                          <span class="sortable-ar">
                            <svg width="1em" height="1em" class="icon icon-arrow-up">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow-up"></use>
                            </svg>Last Update
                          </span>
                                        </th>
                                        <th class="default-table-2__th td-price-up">
                          <span class="sortable-ar grow-ar">
                            <svg width="1em" height="1em" class="icon icon-arrow-up">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow-up"></use>
                            </svg>Price Up To
                          </span>
                                        </th>
                                        <th class="default-table-2__th td-action"><span></span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in hotels" :key="item.id">
                                        <td class="default-table-2-title">
                                            <a href="#" class="name-hotel-td">
                                                <b>{{ item.title }}</b>
                                            </a>
                                        </td>

                                        <td class="td-last-update">
                          <span class="td-av td-light">
                            {{ item.updatedAt }}
                          </span>
                                        </td>
                                        <td class="td-price-up"><span
                                            class="td-light price-up">{{ item.updatedAt }}</span></td>
                                        <td class="td-action">
                                            <button type="button" class="day-trips-activities__table__dropdown-trigger"
                                                    @click="openMenu(item.id)">
                                                <svg width="1em" height="1em" class="icon icon-more ">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                                                </svg>
                                                <div
                                                    :class="['edit-popup edit-popup--short', { 'toup' : index + 1 === hotels.slice((page - 1) * 15, ((page - 1) * 15) + 15).length && index + 1 !== 1 }]"
                                                    v-if="item.menu">
                                                    <div class="form-control-group">
                                                        <button type="button" class="btn form-control-action"
                                                                @click="$router.push('/hotels/' + item.id)"><span
                                                            class="form-control-action__icon icon--green">
                                    <svg width="1em" height="1em" class="icon icon-edit ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                                    </svg></span><span class="form-control-action__text">Edit</span></button>
                                                    </div>
                                                    <div class="form-control-group">
                                                        <button type="button" class="btn form-control-action" @click="$emit('deleteModalHandler', {
                                        entity: 'Hotel',
                                        name: item.title,
                                        handler: deleteHotelHandler,
                                        id: item.id
                                    })"><span
                                                            class="form-control-action__icon icon--red">
                                    <svg width="1em" height="1em" class="icon icon-close ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                    </svg></span><span class="form-control-action__text">Delete</span></button>
                                                    </div>
                                                </div>
                                            </button>
                                        </td>
                                    </tr>


                                    </tbody>
                                </table>
                            </simplebar>
                        </div>

                        <Pagination
                            :page="page"
                            :pageCount="pageCount"
                            @pageController="pageController"
                        />
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import {getHotelsTitles, deleteHotel} from '@/utilites/api'

import simplebar from 'simplebar-vue';

import Pagination from '@/components/Pagination'

export default {
    data() {
        return {
            hotels: [],
            hotelsData: [],
            isLoad: false,
            page: 1,
            pageCount: 0,
            search: '',
        }
    },
    beforeCreate() {
        document.title = 'Hotels'
    },
    mounted() {
        document.title = 'Hotels'
        this.updateData()
    },
    components: {Pagination, simplebar},
    methods: {
        updateData() {
            getHotelsTitles()
                .then(res => {
                    this.hotels = res.map(item => ({...item, menu: false}))
                    this.hotelsData = res.map(item => ({...item, menu: false}))
                    this.isLoad = true
                })
                .catch(() => {
                    this.isLoad = true
                })
            window.addEventListener('click', event => {
                if (!event.target.closest('.day-trips-activities__table__dropdown-trigger')) {
                    this.hotels = this.hotels.map(item => ({...item, menu: false}))
                }
            })
        },
        pageController(page) {
            this.page = page
        },
        pageCountHandler() {
            this.pageCount = Math.ceil(this.hotels.length / 15)
        },
        openMenu(id) {
            this.hotels = this.hotels.map(item => item.id === id ? {...item, menu: !item.menu} : {...item, menu: false})
        },
        deleteHotelHandler(id) {
            deleteHotel(id)
                .then(() => this.updateData())
        }
    },
    watch: {
        hotels() {
            this.pageCountHandler()
        },
        search() {
            if (this.search.length === 0) {
                this.hotels = this.hotelsData
            }
            this.page = 1
            let filtered = this.hotelsData.filter(item => this.search.length ? (item.title && item.title.toLowerCase().includes(this.search.toLowerCase())) ? item : false : item)
            this.hotels = filtered
            this.pageCount = Math.ceil(filtered.length / 15)
        }
    }
}
</script>
